<template>
  <validation-provider
    rules="required"
    :name="'select-service'"
    v-slot="{ errors }"
    tag="div">
    <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
      <v-select
        class="w-100"
        :options="services"
        v-model="service_id"
        :reduce="service => service.id"
        :placeholder="$t('service.selectService')"
        label="code"
        :filterBy="filterByForServices">
        <template slot="no-options">
          {{ $t('service.noServicesMatchingPhrase') }}&hellip;
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-center w-100 normal-white-space">
            <template v-if="option.group_name">{{ option.group_name }} - </template>{{ option.name }}
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center w-100 normal-white-space">
            <template v-if="option.group_name">{{ option.group_name }} - </template>{{ option.name }}
          </div>
        </template>
      </v-select>
    </div>
  </validation-provider>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'select-service',
  props: [
    'serviceID'
  ],
  data () {
    return {
      service_id: 0,
      services: [],
      loadServicesError: false,
    };
  },
  watch: {
    service_id (newValue) {
      this.$bus.$emit('ui-select-service-updated', newValue);
    }
  },
  mounted () {
    this.service_id = this.serviceID;
    this.fetchServices();
  },
  methods: {
    filterByForServices (option, label, search) {
      return (option.code + ' ' + option.group_name + ' ' + option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    fetchServices () {
      let endpointUrl = '/customer-panel/services/all-items';

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointUrl,
        outputKey: 'services',
        errorKey: 'loadServicesError'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.is-v-select-wrapper > div {
  width: 100%;
}
</style>
